'use client';

import { useQuery } from '@tanstack/react-query';

import { type ActivityLocation, getActivityLocations } from '../services/activityLocations.service';

export const activityLocationsKey = (activityId: string) => ['activity-locations', activityId] as const;

/**
 * Read an activity's locations, each carrying its upcoming-booking count. This is
 * read-only: the wizard edits a local DRAFT and submits it WITH the activity update
 * (there are no per-location write endpoints). The list seeds the draft and powers
 * the upcoming-booking badges + edit-impact warning.
 */
export const useActivityLocations = (activityId: string | undefined, opts?: { enabled?: boolean }) =>
  useQuery<ActivityLocation[]>({
    queryKey: activityLocationsKey(activityId ?? ''),
    queryFn: () => getActivityLocations(activityId as string),
    enabled: (opts?.enabled ?? true) && !!activityId
  });
